// components
import {
  ClickAwayListener,
  Divider,
  Paper,
  Popper,
  Tooltip
} from '@mui/material';
import { IconButton } from '@sdb/planning-ui';

// styles
import { StyledBoxFlexColumnSmallGapCenter } from 'components/shared/Box/Box.styles';
import { StyledPaperBox } from './VerticalToolbarActionWrapper.styles';

// hooks
import { MouseEvent, useState } from 'react';

// types
import type { IconType } from '@sdb/planning-ui/ui-3/packages/icons/__generated__';

const VerticalToolbarActionWrapper = ({
  children,
  iconType,
  title,
  divider
}: {
  children: React.ReactNode;
  iconType: IconType;
  title: string;
  divider?: {
    top?: boolean;
    bottom?: boolean;
  };
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = !!anchorEl;
  const id = open ? 'settings-popper' : undefined;

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClickAway = () => {
    setAnchorEl(null);
  };

  return (
    <ClickAwayListener mouseEvent="onMouseUp" onClickAway={handleClickAway}>
      <StyledBoxFlexColumnSmallGapCenter>
        {divider?.top && (
          <Divider orientation="horizontal" variant="middle" flexItem />
        )}
        <Tooltip title={title} placement="left">
          <IconButton type={iconType} size="small" onClick={handleClick} />
        </Tooltip>
        <Popper
          placement="left"
          anchorEl={anchorEl}
          open={open}
          id={id}
          modifiers={[
            {
              name: 'offset',
              options: {
                offset: [0, 8]
              }
            }
          ]}
        >
          <Paper>
            <StyledPaperBox>{children}</StyledPaperBox>
          </Paper>
        </Popper>
        {divider?.bottom && (
          <Divider orientation="horizontal" variant="middle" flexItem />
        )}
      </StyledBoxFlexColumnSmallGapCenter>
    </ClickAwayListener>
  );
};

export default VerticalToolbarActionWrapper;
